import ImageGeneratorView from "@features/tools/view/images-view";

const ImageGenerator = () => {
  return <ImageGeneratorView />;
};

export default ImageGenerator;
